import apiClient from "./axiosConfig";

export interface CreateProfilePayload {
  name: string;
  dob: string;
  sex: "male" | "female";
  city: string;
  country_code: string;
  timezone: string;
  latitude: number;
  longitude: number;
  is_main: boolean;
  forecast: number;
}

export const createProfile = async (data: CreateProfilePayload) => {
  const response = await apiClient.post("/api/profiles", data);
  return response.data;
};

export const fetchProfiles = async () => {
  const response = await apiClient.get("/api/profiles");
  return response.data;
};

export const fetchNatalChart = async () => {
  const response = await apiClient.get("/api/natal-chart/main");
  return response.data;
};

export const updateProfile = async (
  id: number,
  data: Partial<{ name: string; city: string; dob: string }>
) => {
  const response = await apiClient.put(`/api/profiles/${id}`, data);
  return response.data;
};
